import type { FC } from 'react';
import { GlitterIcon } from '@THC/components/Icons';
import Markdown from 'marked-react';

import type { ChatItem } from 'Features/AiCompanion/services';

import { renderer } from './renderer';

import styles from './AgentItem.module.scss';

interface AgentItemProps {
	item: ChatItem;
}

// TODO: Can we get an id from the turn in here? So we can pair queries with their vdp clicks?
// If item has an id we can add it to the link in the renderer?
// We might have to add the renderer construction in here rather than importing and sharing, unless we do some sort of callback
// Do we even have a reliable unique id for turns?
// We can probably only do this once we port over to the new backend
export const AgentItem: FC<AgentItemProps> = ({ item }) => {
	return (
		<div className={styles.content}>
			<GlitterIcon data-agent-icon />
			<div className={styles.html}>
				<Markdown breaks gfm openLinksInNewTab renderer={renderer} value={item?.content ?? ''} />
			</div>
		</div>
	);
};
